import React, { useState } from 'react';
import { CustomerType } from 'propTypes';
import PlaidAchInput from './PlaidAchInput';
import ManualAchInput from './ManualAchInput';
import PaymentTestModeWarning from './PaymentTestModeWarning';

const AchInput = (props) => {
  const { customer } = props;
  const [manualInput, setManualInput] = useState(false);

  return (
    <React.Fragment>
      <div className='payment-ach-toggle'>
        <button
          type='button'
          onClick={() => setManualInput(false)}
          className={`btn ach-plaid-toggle ${manualInput ? 'btn-light' : 'btn-primary'}`}
        >
          Select Bank Account
        </button>

        <button
          type='button'
          onClick={() => setManualInput(true)}
          className={`btn ach-manual-toggle ${manualInput ? 'btn-primary' : 'btn-light'}`}
        >
          Enter Routing Details Manually
        </button>
      </div>

      <PaymentTestModeWarning testMode={customer.ach_payment_info.test_mode} />

      { manualInput ? <ManualAchInput {...props} /> : <PlaidAchInput {...props} /> }
    </React.Fragment>
  );
};

AchInput.propTypes = {
  customer: CustomerType.isRequired
};

export default AchInput;
